/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 19.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import MetisMenu from "react-metismenu";
import RouterLink from "./RouterLink";

class LeftMenu extends React.Component {
    static propTypes = {
        menu: PropTypes.array.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    //                 noBuiltInClassNames={true}

    render() {
        return (
            <MetisMenu
                content={this.props.menu}
                LinkComponent={RouterLink}
                className="nav"
            />
        );
    }
}

export default LeftMenu;
